import styles from "./styles.module.scss";
export const VerticalDivider = () => {
  return <span className={styles.verticalDivider}>&#124;</span>;
};
